import { ReactElement } from "react";
import { useAccount, useMsal } from "@azure/msal-react";
import {
  Box,
  Button,
  Center,
  Circle,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  StackProps,
  useColorModeValue,
} from "@chakra-ui/react";

import { useAuth } from "contexts/AuthProvider";
import { Logo } from "Logo";
import { ChevronDownIcon, LogoutIcon } from "icons";

const Header = (props: StackProps): ReactElement => {
  const { logout } = useAuth();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] ?? {});

  const bg = useColorModeValue("white", "grey.800");

  return (
    <Box boxShadow="large" h={20} position="sticky" top={0} bg={bg} zIndex={2}>
      <Center h="100%" alignItems="center">
        <HStack {...props}>
          <Circle p={1} bg="white">
            <Logo h={14} />
          </Circle>
          <Spacer />
          <Menu placement="bottom-end">
            <MenuButton
              as={Button}
              variant="ghost"
              rightIcon={<ChevronDownIcon color="current" />}
              display="flex"
              alignItems="center"
              colorScheme="black"
              data-testid="user-account-menu"
            >
              {account?.name ?? "Name"}
            </MenuButton>
            <MenuList>
              <MenuItem
                icon={<LogoutIcon />}
                onClick={logout}
                data-testid="logout-button"
              >
                Sign Out
              </MenuItem>
            </MenuList>
          </Menu>
        </HStack>
      </Center>
    </Box>
  );
};

export default Header;
